/**
 * Shared `common` i18next namespace — English.
 *
 * Every string here is rendered by BOTH apps (CMA `apps/mobile` and CWA `apps/web`).
 * A string belongs in this namespace only when both apps show identical copy;
 * app-specific copy stays in each app's own namespaces. Copy changes here change
 * both apps at once.
 */
export default {
  // Action + link labels
  CANCEL: 'Cancel',
  CLEAR: 'Clear',
  YES: 'Yes',
  NO: 'No',
  NEXT: 'Next',
  EDIT: 'Edit',
  RESEND: 'Resend',
  SUPPORT: 'Support',
  CONTACT_SUPPORT: 'Contact Support',
  PRIVACY_POLICY: 'Privacy Policy',
  TERMS_AND_CONDITIONS: 'Terms & Conditions',

  // Address form field labels
  STREET: 'Street',
  APARTMENT_UNIT: 'Apartment/Unit Number',
  FLOOR_SUITE: 'Floor/Suite Number',
  CITY: 'City',
  STATE: 'State',
  ZIPCODE: 'Zipcode',

  // Form validation + error messages
  VALIDATION: {
    GENERIC_ERROR: 'An error has occurred.',
    REQUIRED_FIELD: 'This field is required.',
    TYPE_ERROR_STRING: 'This field must be a string.',
    TYPE_ERROR_NUMBER: 'This field must be a number.',
    MAX_LENGTH_250: 'Must not exceed 250 characters.',
    MAX_LENGTH_20: 'Must not exceed 20 characters.',
    VERIFY_PHONE_CODE_LENGTH: 'Must be exactly 6 characters.',
    PHONE_NUMBER: 'Must be a valid phone number.',
    ZIP_CODE_LENGTH: 'Must be exactly 5 or 9 characters.',
    // Trailing space is intentional: both apps append a tappable "contact support" link.
    ZIP_CODE_NOT_AVAILABLE:
      "Sorry, our warehouse doesn't currently deliver to that zip code yet. If you need further assistance, please ",
    NOT_A_STATE: 'Must be a valid U.S. state.',
    NOT_A_PROPERTY_TYPE: 'Must be a valid property type.',
  },

  // Package status labels shown on tracking/order timelines
  STATUS: {
    ORDER_INFO_RECEIVED: 'Order info received',
    DELIVERED: 'Delivered',
    OUT_FOR_DELIVERY: 'Out for delivery',
    IN_TRANSIT: 'In transit',
    AT_VEHO_FACILITY: 'At Veho facility',
    ARRIVED_AT_VEHO_FACILITY: 'Arrived at Veho facility',
    DEPARTED_CLIENT_FACILITY: 'Departed {{clientDisplayName}} facility',
    ISSUE_WITH_ORDER: 'Issue with order',
    DELIVERY_ISSUE: 'Delivery issue',
    PACKAGE_DELAYED: 'Package delayed',
  },
} as const
